module.exports = "images/doc-city-add.908b4ae9da25b13d23e8d298f1f06de6.png";